import React from 'react';
import { Modal, Typography } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import './ViewAllContainer.scss';
import { ViewAllTitle } from '../../types';

interface ViewAllContainerProps {
  title?: ViewAllTitle | null;
  onClose?: () => void;
  children: React.ReactNode;
}

const ViewAllContainer: React.FC<ViewAllContainerProps> = ({ title, onClose, children }) => {
  const isOpen = !!title;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      className="view-all-container-modal"
      disableRestoreFocus
    >
      <div className="view-all-container-modal__container">
        <div className="view-all-container-modal__header">
          <Typography variant="h4" className="view-all-container-modal__header__title">
            {title}
          </Typography>
          <CloseOutlined
            fontSize="small"
            className="view-all-container-modal__header__close"
            onClick={handleClose}
          />
        </div>

        <div className="view-all-container-modal__content">{children}</div>
      </div>
    </Modal>
  );
};

export default ViewAllContainer;
